function collectionSlider(selector,settings){
  $(selector).slick(settings);
}

$('[data-custombox]').on('click',function(e){
  e.preventDefault();
  let content_id = $(this).attr('data-src'),selectContent = $(content_id);

  if(selectContent.hasClass('active')){
   selectContent.removeClass('active');
    selectContent.slideUp();
  }else{
    selectContent.addClass('active');
     selectContent.slideDown();
  }
});

$("#meal-calculator").on('change',function(e){
  e.preventDefault();
  let oneBagPerMealMonthly = 19,oneBagPerMealYearly = 228;
  let totalMeals = 0;
  let getTotalBags = parseInt($('[name="bag"]:checked').val()),
      Duration = $('[name="Duration"]:checked').val(); 

    if(Duration == "1"){
       totalMeals = oneBagPerMealMonthly * getTotalBags;
      $('.calculation-result').html(`Your order provides <strong>${totalMeals} meals per month</strong> for shelter dogs.`)
    }else{
       totalMeals = oneBagPerMealYearly * getTotalBags;
      $('.calculation-result').html(`Over 12 months, that’s <strong>${totalMeals} meals provided!</strong>`)
    }
    
});